import React, { useEffect, useCallback, useState } from 'react';
import { useTopbannerContext } from '@contexts';
import { useGTM, useNewUser } from '@hooks';
import cn from 'classnames';

import styles from './styles/index.module.scss';

const Banner = () => {
  const {
    campaign: {
      creativeDesktop = {},
      creativeMobile = {},
      redirectionUrl,
      name,
      uuid,
    } = {},
    platform,
    market,
    pageName,
    ancestors,
    getTopbanner,
    hasTopbannerBeenFetched,
    userId,
  } = useTopbannerContext();
  const [pushToGTM] = useGTM();
  const isNewUser = useNewUser();

  const isMobile = () =>
    typeof window !== 'undefined' &&
    window.innerWidth &&
    window.innerWidth < 1000;
  const isDesktop = () =>
    typeof window !== 'undefined' &&
    window.innerWidth &&
    window.innerWidth >= 1000;

  /* eslint-disable no-nested-ternary */
  const campaignAvailable = isMobile()
    ? !!creativeMobile.url
    : isDesktop()
    ? !!creativeDesktop.url
    : false;
  const shouldCollapse = hasTopbannerBeenFetched && !campaignAvailable;

  const [sentToGTM, setSentToGTM] = useState(false);

  useEffect(() => {
    getTopbanner(platform, market, pageName, ancestors, userId, isNewUser);
  }, []);

  useEffect(() => {
    if (pushToGTM && name && uuid && campaignAvailable && !sentToGTM) {
      setSentToGTM(true);
      setTimeout(
        () =>
          pushToGTM({
            event: 'display_campaign',
            campaign_id: uuid,
            campaign_name: name,
            space_slug: 'top_banner',
          }),
        2000,
      );
    }
  }, [pushToGTM, name, uuid, sentToGTM]);

  const sendToGTM = useCallback(() => {
    if (pushToGTM) {
      pushToGTM({
        event: 'click_campaign',
        campaign_id: uuid,
        campaign_name: name,
        space_slug: 'top_banner',
      });
    }
  }, [pushToGTM, uuid, name]);

  return (
    <div
      className={cn(
        styles.wrapper,
        shouldCollapse ? styles['wrapper--collapsed'] : '',
      )}
    >
      <a href={redirectionUrl} onClick={sendToGTM}>
        {campaignAvailable ? (
          <picture>
            <source media="(max-width: 767px)" srcSet={creativeMobile.url} />
            <img src={creativeDesktop.url} alt="" />
          </picture>
        ) : null}
      </a>
    </div>
  );
};

Banner.displayName = 'Banner';

export default Banner;
